export enum Vendor {
  Envio = "envio",
  Graph = "graph",
}
